import { NgModule } from '@angular/core';
import {
  FormsModule as AngularFormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { FormsModule } from '@features/forms/forms.module';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { IconsModule } from '../icons/icons.module';
import { FeedbackButtonComponent } from './feedback-button.component';
import { FeedbackFormComponent } from './feedback-form.component';
import { FeedbackModalComponent } from './feedback-modal.component';
import { FeedbackService } from './feedback.service';

@NgModule({
  imports: [
    AngularFormsModule,
    FormsModule,
    IconsModule,
    NgbModalModule,
    ReactiveFormsModule,
  ],
  declarations: [
    FeedbackButtonComponent,
    FeedbackFormComponent,
    FeedbackModalComponent,
  ],
  providers: [FeedbackService],
  exports: [
    FeedbackButtonComponent,
    FeedbackModalComponent,
    FeedbackFormComponent,
  ],
})
export class FeedbackModule {}
